var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 22.7l2.5-18.6C37 3.5 34.6 2 32 2c-2.6 0-5 1.5-7.5 2.2c-2.5.6-5.3.5-7.5 1.8s-3.6 3.8-5.4 5.6C9.8 13.4 7.3 14.8 6 17c-1.3 2.2-1.2 5-1.9 7.5C3.5 27 2 29.4 2 32c0 2.6 1.5 5 2.2 7.5c.6 2.5.5 5.3 1.8 7.5s3.8 3.6 5.6 5.4c1.8 1.8 3.1 4.3 5.4 5.6c2.2 1.3 5 1.2 7.5 1.9c2.5.6 4.9 2.1 7.5 2.1c2.6 0 5-1.5 7.5-2.2c2.5-.7 5.3-.6 7.5-1.9c2.2-1.3 3.6-3.8 5.4-5.6c1.8-1.8 4.3-3.1 5.6-5.4c1.3-2.2 1.2-5 1.9-7.5c.6-2.4 2.1-4.8 2.1-7.4c0-2.6-2.1-8.1-2.1-8.1l-23-1.2",
    fill: "#dda85f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4 22.4c-1 .3-2.4.2-3.9-.4c-2.1-.8-3.4-2.5-3.8-4.5c-1 .3-3.4 0-5-1c-2.4-1.5-2.9-5.7-2.9-5.7c-2.7-.8-4.7-4-4.4-6.7c-2.2-.6-5-.5-7.4-.5c-2.4 0-4.6 1.4-6.8 2c-2.3.6-4.9.5-6.9 1.7s-3.3 3.5-4.9 5.1c-1.7 1.7-4 2.9-5.1 4.9c-1.2 2-1.1 4.6-1.7 6.9c-.6 2.2-2 4.4-2 6.8c0 2.4 1.4 4.6 2 6.8c.6 2.3.5 4.9 1.7 6.9s3.5 3.3 5.1 4.9c1.7 1.7 2.9 4 4.9 5.1c2 1.2 4.6 1.1 6.9 1.7c2.2.6 4.4 2 6.8 2c2.4 0 4.6-1.4 6.8-2c2.3-.6 4.9-.5 6.9-1.7s3.3-3.5 4.9-5.1c1.7-1.7 4-2.9 5.1-4.9c1.2-2 1.1-4.6 1.7-6.9c.6-2.2 3-4 3.3-6.4c.8-3.9-1.2-8.3-1.3-9",
    fill: "#f2cb7d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#dda85f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1 10.8l-1.4 1.4l-1.3-1.4l1.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8 17.8l-.6.7l-.7-.7l.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8 13.2l-.7.7l-.7-.7l.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6 7.1l-.7.7l-.7-.7l.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2 20.3l-.7.7l-.7-.7l.7-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 17.8l-.7.7l-.7-.7l.7-.7z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 20.6c-1 1.7.5 4.8 2.5 5.7c2.9 1.2 4.6 1.4 6.4-1.7c.6-1.1 1.4-4 1.1-4.7c-.4-1-2.1-3-3.2-3c-3.1.1-6.1 2.5-6.8 3.7",
    fill: "#6d4934"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 20.6c-.7 1.2 1.1 4.8 3.5 4.5c3.3-.4 3-7.2 1.6-7.2c-2.4 0-4.6 1.8-5.1 2.7",
    fill: "#a37f6a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2 39.1c1.4-.4 2.4-2.9 1.8-4.4c-.9-2.3-1.8-3.3-4.4-2.6c-.9.3-3 1.4-3.2 1.9c-.3.8-.5 2.8.1 3.4c1.7 1.7 4.7 2 5.7 1.7",
    fill: "#6d4934"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 36.7c1.1-.3 2.8-3.7 1-3.9c-3.1-.5-5.5 1-5.2 2.7c.3 1.7 3.4 1.4 4.2 1.2",
    fill: "#a37f6a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9 44.5c-.3-1.2-2.5-2.1-3.9-1.5c-2 .8-2.9 1.5-2.2 3.8c.2.8 1.2 2.6 1.7 2.7c.7.3 2.4.4 2.9-.1c1.5-1.4 1.7-4 1.5-4.9",
    fill: "#6d4934"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 43.6c-.2-.9-4.4.4-4 2c.8 2.7.8 3.1 1.6 3c1.5-.4 2.5-4.3 2.4-5",
    fill: "#a37f6a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1 25.5c-1.2.3-2.1 2.5-1.5 3.9c.8 2 2.7 2.3 4.8 1.2c1.8-.9 1.9-4.1 1.4-4.7c-1.5-1.5-3.8-.6-4.7-.4",
    fill: "#6d4934"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 26.6c-.6.7-1.1 3.5.4 3.1c2.7-.8 4.6-3.5 3.4-3.9c-1.5-.5-3.1 0-3.8.8",
    fill: "#a37f6a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d4934",
    d: "M22.74 16.112l1.98-1.98l1.98 1.98l-1.98 1.98z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#dda85f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.706 33.483l1.979-1.98l1.98 1.979l-1.979 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.698 44.811l1.98-1.98l1.98 1.98l-1.98 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.038 39.289l2.687-2.687l2.687 2.687l-2.687 2.687z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.696 9.827l2.687-2.687l2.687 2.687l-2.687 2.687z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#6d4934"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.122 46.347l1.98-1.98l1.98 1.98l-1.98 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.076 35.215l1.98-1.98l1.98 1.98l-1.98 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.812 24.637l.99-.99l.99.99l-.99.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.726 38.266l.99-.99l.99.99l-.99.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.adb1c78a70629467747ef5e1dfc58146.svg";
export { ForwardRef as ReactComponent };